var _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3, _rect13, _rect14, _rect15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2",
    "data-name": 2,
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,39V14.012L17.5,0l7.875,6.306V4.437h4.083V9.575L35,14.012V39Z",
    fill: "#e1f4fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(2.674 3.195)",
    fill: "#e1f4fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.89553833007812 32.88513946533203 L 0.7499982118606567 32.88513946533203 L 0.7499982118606567 12.07184791564941 L 14.82565689086914 0.9557543396949768 L 28.89553833007812 12.07175445556641 L 28.89553833007812 32.88513946533203 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.82556056976318 1.911504745483398 L 1.499998092651367 12.43521881103516 L 1.499998092651367 32.13513946533203 L 28.14553833007812 32.13513946533203 L 28.14553833007812 12.43503952026367 L 14.82556056976318 1.911504745483398 M 14.82574844360352 -3.814697265625e-06 L 29.64553833007812 11.70846748352051 L 29.64553833007812 33.63513946533203 L -1.9073486328125e-06 33.63513946533203 L -1.9073486328125e-06 11.70846748352051 L 14.82574844360352 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M0,39V14.012L17.5,0,35,14.012V39Zm32.32-2.17V14.9L35,14.012,32.32,14.9,17.5,3.195,2.674,14.9,0,14.012l2.674.892V36.83Z",
    fill: "#00a3da"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 2.674,
    height: 0.955,
    transform: "translate(0 16.646)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 2.674,
    height: 0.955,
    transform: "translate(0 21.878)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 2.674,
    height: 0.955,
    transform: "translate(0 27.11)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 2.674,
    height: 0.955,
    transform: "translate(0 32.341)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    width: 2.68,
    height: 0.955,
    transform: "translate(32.32 16.646)",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    width: 2.17,
    height: 1.186,
    transform: "translate(7.13 36.83) rotate(90)",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    "data-name": "Rectangle",
    width: 2.17,
    height: 1.186,
    transform: "translate(7.13 36.83) rotate(90)",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    "data-name": "Rectangle",
    width: 2.17,
    height: 1.186,
    transform: "translate(14.248 36.83) rotate(90)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    "data-name": "Rectangle",
    width: 2.17,
    height: 1.186,
    transform: "translate(21.367 36.83) rotate(90)",
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    "data-name": "Rectangle",
    width: 2.17,
    height: 1.186,
    transform: "translate(28.485 36.83) rotate(90)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    "data-name": "Rectangle",
    width: 2.441,
    height: 1.07,
    transform: "translate(31.204 10.983) rotate(135)",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    "data-name": "Rectangle",
    width: 2.441,
    height: 1.07,
    transform: "translate(25.272 6.227) rotate(135)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-13",
    "data-name": "Rectangle",
    d: "M.157.408,2.672.074l-.117,1.1L.042,1.5Z",
    transform: "translate(11.408 8.291) rotate(-135)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-14",
    "data-name": "Rectangle",
    d: "M.171.314,2.628.073,2.5,1.133.039,1.408Z",
    transform: "translate(6.363 12.26) rotate(-135)",
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    "data-name": "Rectangle",
    width: 2.68,
    height: 0.955,
    transform: "translate(32.32 21.878)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    "data-name": "Rectangle",
    width: 2.68,
    height: 0.955,
    transform: "translate(32.32 27.11)",
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17",
    "data-name": "Rectangle",
    width: 2.68,
    height: 0.955,
    transform: "translate(32.32 32.341)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAir);
export default __webpack_public_path__ + "static/media/air.d0231d7add722bf29703a99970add1ac.svg";
export { ForwardRef as ReactComponent };